<template>
  <main class="any-link">
    <template v-if="extension.payload.length > 0 && !!link.title" v-for="(link, index) in extension.payload">
      <div class="link">
        <div class="title">
          {{ link.title }}
        </div>
        <div class="details">
          <div class="thumbnail-image" :style="{ backgroundImage: `url(${link.thumbnail ? cleanThumbnailUrl(link.thumbnail.url) : defaultThumbnailImage })` }"></div>
          <div class="ellipsis">
            <span>{{ formatUrl(link.url) }}</span>
          </div>
        </div>
      </div>
    </template>
  </main>
</template>

<script>
import defaultThumbnailImage from "stashboard/default_thumbnail_image.png";
import {stripHttpProtocolUtil} from "../../../../utilities";

export default {
  props: {
    extension: Object
  },

  name: "any-link-preview",

  data(){
    return {
      defaultThumbnailImage,
    }
  },

  methods: {
    cleanThumbnailUrl(url) {
      if(typeof url === 'string' && url.startsWith && url.startsWith("http")) {
        return `${url}?h=47&w=47`;
      }
      return url;
    },

    formatUrl(url){
      return stripHttpProtocolUtil(url);
    }
  }
}
</script>

<style scoped>
.any-link {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(100px,1fr));
  width: 100%;
  overflow: hidden;
}

.any-link .link {
  height: 51px;
  border-right: 1px solid #128ff9;
  border-bottom: 1px solid #128ff9;
  margin-right: -1px;
  margin-bottom: -1px;
}


.any-link .title {
  display: block;
  font-size: .575em;
  padding-left: 1ch;
}

.any-link .details {
 display: flex;
 flex-direction: row;
 align-items: center;
 padding-left: 3px;
}

.any-link .thumbnail-image {
  background-color: #fff;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 50%;
  height: 24px;
  width: 24px;
}

.any-link .thumbnail-image img {
  height: auto;
  width: 100%;
}

.any-link .ellipsis {
  padding-left: 3px;
  font-size: .6rem;
  width: 65px;
  text-overflow: ellipsis;
  overflow: hidden;
}
</style>
